import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";

export const accountSettingRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ACCOUNT_SETTING,
    path: "account/setting",
    component: () => import("@/pages/profile/setting.vue")
  };
};
